(function () {
  'use strict'

  /**
     * @ngdoc module
     * @name FormlyRequiredInputWrapper
     * @module thismoment.common.formly.wrappers.required
     *
     * @description
     * Adds ngMessages for required inputs, inputs with max and min lengths, and email inputs to a Formly form so long as the required input module is also included/required
     */

  var MODULE_NAME = 'thismoment.common.formly.wrappers.required'
  var templateUrl = require('./tpl/required.html')

  require('./scss/required.scss')

  require('angular')
    .module(MODULE_NAME, [
      require('angular-formly'),
      require('angular-formly-templates-bootstrap'),
      require('angular-messages')
    ])
    .run(requiredWrapperConfig)

  requiredWrapperConfig.$inject = ['formlyConfig']
  function requiredWrapperConfig (formlyConfig) {
    formlyConfig.setWrapper({
      templateUrl: templateUrl
    })
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/formly/wrappers/required.js